import React, { useState, useEffect } from "react";
import {
    Card,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Divider
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import Header from '../../../components/header.tsx';
import Footer from '../../../components/footer.tsx';
import signInBanner1 from '../../../assets/signin_banner.jpg';
import signInBanner2 from '../../../assets/signin_banner1.jpeg';
import signInBanner3 from '../../../assets/signin_banner-2.jpeg';



const AP_Email_Verification = () => {
    const sidebanner = [signInBanner1, signInBanner2, signInBanner3];
    const [bannercurrentIndex, setBannerCurrentIndex] = useState(0);


    useEffect(() => {
        const interval = setInterval(() => {
            setBannerCurrentIndex((prev) => (prev + 1) % sidebanner.length);
        }, 3000);

        return () => clearInterval(interval);
    }, []);
    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* body */}
            <Box className="primary-box">
                {/* Left side with image ads */}
                <Box
                    className="secondary-box"
                    sx={{
                        padding: 2,
                    }}
                    display={{
                        xs: 'none',
                        md: 'block'
                    }}
                >
                    <img
                        src={sidebanner[bannercurrentIndex]}
                        alt="Ad Banner"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            width: '100%'
                        }}
                    />
                </Box>
                {/* password assistance card */}
                <Box className="secondary-box" sx={{ flexDirection: 'column' }}>
                    <Card className="auth-card"
                        sx={{
                            p: 3,
                            // width: '28%'
                        }}
                    >
                        {/* Logo */}
                        <Box className="auth-logo"
                            sx={{
                                mx: "auto",
                                mb: 2,
                                // width: '15%'
                            }}
                        >
                            <Typography
                                sx={{ fontSize: "40px", color: "#fff", fontWeight: "bold" }}
                            >
                                F5
                            </Typography>
                        </Box>

                        {/* Title */}
                        <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 2, textAlign: "left" }}
                        >
                            Enter verification code
                        </Typography>
                        <Typography
                            sx={{ mb: 2, textAlign: "left", fontSize: '14px' }}
                        >
                            For your security, we've sent the code to your email k*****@gmail.com
                        </Typography>

                        <>
                            {/* Email Field */}
                            <TextField
                                fullWidth
                                type="code"
                                label="Verification Code"
                                /* value={email}
                                onChange={(e) => setEmail(e.target.value)} */
                                size="small"
                                placeholder="Code"
                            />
                            <Typography sx={{
                                color: '#C32032', '&:hover': {
                                    textDecoration: 'underline'
                                }, mb: 2, cursor: 'pointer'
                            }}>Resend Code</Typography>
                            <Typography sx={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '14px', mb: 2 }}><InfoIcon sx={{ color: '#1E90FF', fontSize: '24px' }} />please wait 60 seconds before requesting another code.</Typography>
                        </>

                        {/* Submit Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            // onClick={handleSubmit}
                            sx={{
                                textTransform: "none",
                                fontWeight: "bold",
                                backgroundColor: "#C32032",
                                mb: 1,
                            }}
                        >
                            Submit Code
                        </Button>
                    </Card>
                    {/* <Divider sx={{ my: 2, width: '100%' }} />

                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#C32032',
                        }}
                    >
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Conditions of use</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Privacy Policy</Typography>
                        <Typography sx={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            cursor: 'pointer'
                        }}>Help</Typography>
                    </Box>
                    <Box
                        sx={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'center',
                            textAlign: 'center',
                            fontSize: '13px',
                            color: '#666',
                            mt: 2
                        }}
                    >
                        <Typography>©2025, FortuneFive.com</Typography>
                    </Box> */}
                </Box>
            </Box>
            {/* end body */}

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}

export default AP_Email_Verification;